import axios from 'axios';

// IMPORTANT: This should ideally come from a .env file, but this setup works.
const REACT_APP_TEST ='https://api.nownfc.com:5007/api';


const api = axios.create({
  baseURL: REACT_APP_TEST,
});

// --- THIS IS THE KEY PART ---
// An interceptor automatically adds the auth token to every request.
// This is an excellent pattern, and it means we don't have to
// add the token manually in every function.
api.interceptors.request.use((config) => {
  // Get admin info from local storage
  const adminInfo = JSON.parse(localStorage.getItem('adminInfo'));

  // If logged in, add the token to the headers
  if (adminInfo && adminInfo.token) {
    config.headers.Authorization = `Bearer ${adminInfo.token}`;
  }

  return config;
}, (error) => {
  return Promise.reject(error);
});


// --- Generic Functions ---
// A generic function to fetch paginated data from any endpoint.
const fetchData = async (endpoint, page = 1, limit = 10) => {
  try {
    const response = await api.get(`/${endpoint}`, {
      params: { page, limit },
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching ${endpoint}:`, error);
    // Rethrow the error so the component can catch it and display a message.
    throw error;
  }
};

// A generic function to delete an item from any endpoint.
const deleteItem = async (endpoint, id) => {
  try {
    const response = await api.delete(`/${endpoint}/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting item from ${endpoint}:`, error);
    throw error;
  }
};


// --- Specific API Calls ---

// Orders
export const fetchOrders = (page, limit) => fetchData('orders', page, limit);
export const deleteOrder = (id) => deleteItem('orders', id);

// Users
export const fetchUsers = (page, limit) => fetchData('users', page, limit);
export const deleteUser = (id) => deleteItem('users', id);

// Login Records
export const fetchLoginRecords = (page, limit) => fetchData('login-records', page, limit);
export const deleteLoginRecord = (id) => deleteItem('login-records', id); 

// Contact Submissions
export const fetchContactSubmissions = (page, limit) => fetchData('contact', page, limit);
export const deleteContactSubmission = (id) => deleteItem('contact', id);

// =======================================================